

export const contactsData = {
    email: 'ebuds.elrond@gmail.com',
    phone: '+40755308857',
    address: 'Distributed Worldwide ',

    sheetAPI: 'https://sheetdb.io/api/v1/996pikthxx27q'
}